import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../environments/environment';
import { File360Error } from './error.model';
import { CommandService, api } from './command.service';
import { User } from './user.model';
import { Config } from './config.model';

import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  private deviceInfo: DeviceInfo;
  private currentUser: User = new User({ Name: "Unknown" });
  private appConfig: Config | undefined;

  constructor(private http: HttpClient,
    private command: CommandService,
    private deviceService: DeviceDetectorService) {

    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  setUser(user: User) {
    if (user)
      this.currentUser = user;
  }

  setConfiguration(config: Config) {
    this.appConfig = config;
    console.log(this.appConfig);
  }

  forgetUser() {
    this.currentUser = new User({ Name: "Unknown" });
  }

  logError(f360Error: File360Error) {
    if (this.canUseConsole()) {
      console.error(this.formatMessage(`${f360Error.Id} - ${f360Error.Message}`));
      console.error(f360Error);
    }
    if (this.appConfig != undefined && (this.appConfig.clientLogging || this.appConfig.perClientLogging)) {
      this.logToServer(f360Error);
    }
  }

  logWarning(message: string) {
    if (this.canUseConsole()) {
      console.warn(this.formatMessage(message));
    }
  }

  logMessage(message: string) {
    if (this.canUseConsole()) {
      console.log(this.formatMessage(message));
    }
  }

  logAlert(message: string) {
    alert(this.formatMessage(message));
    if (this.canUseConsole()) {
      console.log(this.formatMessage(message));
    }
  }

  // Private methods
  private formatMessage(message: string): string {
    const today = new Date();
    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() + ":" + today.getMilliseconds();
    const dateTime = date + ' ' + time;
    const msg = dateTime + " : " + environment.productVersion + " : " + this.deviceInfo.browser + " " + this.deviceInfo.browser_version + " : " + message;
    return msg;
  }

  private canUseConsole(): boolean {
    if (!window.console || !console.log) {
      return false;
    }
    return true;
  }

  private logToServer(f360Error: File360Error): void {
    try {
      let message = {
        UserName: this.currentUser.Name!,
        Message: this.formatMessage(`${f360Error.Id} : ${f360Error.Message} ` + this.getStackTrace(f360Error.Err))
      };
      this.http.post(this.command.getUrl(api.Log), message).subscribe();
    } catch (error) {
      this.getStackTrace(f360Error.Err);
      console.log(`Error : logToServer : ${error.message}`);
    }
  }

  private getStackTrace(ex: Error): string {
    let stackTrace: string = "No stack available!";
    try {
      if (ex.stack) {
        stackTrace = ex.stack;
      }
      if (this.canUseConsole()) {
        console.log("Stack : " + stackTrace);
      }
      return stackTrace;

    } catch (error) {

      const msg: string = `Error : getStackTrace : ${error.message}`;
      if (this.canUseConsole()) {
        console.log("Stack : " + msg);
      }
      return "";
    }
  }
}
